const EMAIL_ERROR:string = 'Este email ya está en uso.';
const EMAIL_OR_PASSWORD_ERROR:string  = 'Usuario o contraseña son inválidos';
const EDIT_USER_INFO_ERROR:string = 'Este email ya está en uso.';

export const modules = { EMAIL_ERROR, EMAIL_OR_PASSWORD_ERROR, EDIT_USER_INFO_ERROR};